import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { some } from 'lodash';
import { finalize, type Observable } from 'rxjs';
import { AppService } from '../../app.service';

@Injectable()
export class LoadingHttpInterceptor implements HttpInterceptor {
  private readonly appService = inject(AppService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this.setLoading(req, true);

    return next.handle(req).pipe(
      finalize(() => {
        this.setLoading(req, false);
      }),
    );
  }

  private setLoading(req, loading) {
    const isApiRequest = req.url.includes('/api');

    const ignoreEndpoints = [
      '/count',
      '/overview',
      '/tenants',
      '/creditors',
      '/search',
    ];
    const ignore = some(ignoreEndpoints, (e) => req.url.includes(e));

    if (isApiRequest && !ignore) {
      this.appService.loading.set(loading);
    }
  }
}
